/* eslint-disable @typescript-eslint/no-explicit-any */
import AudioPlayerIns from "@/component/AudioPlayer/AudioPlayerIns";
import {
  handleStartRecording,
  handleStopRecording,
} from "@/utils/recordingHandler";
import { subscribeUseAIMic } from "@/utils/window";
import { useEffect, useRef } from "react";
import useLoginStore from "@/store/login.store";
import { useNavigate } from "react-router-dom";

interface IAIData {
  starttype: string;
  startdevice?: string;
  starttimestamp?: number;
}
const useSubscribePressEvent = () => {
  const hasLogin = useLoginStore((state) => state.hasLogin);
  const isPlayingRef = useRef(false);
  const hasLoginRef = useRef(false);
  const navigate = useNavigate();
  hasLoginRef.current = hasLogin;

  const handleAIData = (data: IAIData) => {
    console.log('isPlaying', isPlayingRef.current)
    if (isPlayingRef.current) return; // 如果当前还在播放中，不处理
    isPlayingRef.current = true;
    let audioName = "";
    let audioEndedCb = null;
    const isHomePage = location.pathname.indexOf("home") !== -1 || location.pathname === '/';
    const isRecordPage = location.pathname.indexOf("record") !== -1;
    const { starttype, startdevice, starttimestamp } = data;
    console.log(
      "subscribeUseAIMicData",
      starttype,
      startdevice,
      starttimestamp,
      location.pathname
    );
    // 首页短按
    if (starttype === "press" && isHomePage) {
      audioName = "toStartTip";
    }
    // 录制中短按
    else if (starttype === "press" && isRecordPage) {
      audioName = "toStopTip";
    }
    // 首页长按
    else if (starttype === "longpress" && isHomePage) {
      audioName = "hasStartTip";
      const startErrorCb = () => {
        navigate('/home', {replace: true});
      }
      audioEndedCb = () => handleStartRecording(startErrorCb);
    }
    // 录制中长按
    else if (starttype === "longpress" && isRecordPage) {
      audioName = "hasStopTip";
      audioEndedCb = handleStopRecording;
    }
    console.log("播放bm22/bm50音频链接", audioName);
    if(!audioName){
      isPlayingRef.current = false;
      return;
    }

    const audioPlayerIns: AudioPlayerIns | null = new AudioPlayerIns({
      audioSrc: `/${audioName}.mp3`,
      audioDuration: 15,
      onIsPlayingChange: (isPlaying: boolean) => {
        console.log("播放bm22/bm50音频状态", isPlaying);
        if (!isPlaying) {
          isPlayingRef.current = false;
        }
      },
      onLoadError: () => {
        isPlayingRef.current = false;
      }
    });
    audioEndedCb && audioEndedCb();
    audioPlayerIns.toggle();
  };

  const subscribeUseAIMicCb = (data: IAIData) => {
    console.log("subscribeUseAIMic", data);
    // 未登录，将当前数据加入待处理
    if (!hasLoginRef.current) {
      return;
    }
    handleAIData(data);
  };
  
  // 监听启动参数
  useEffect(() => {
    // 初始化
    // const queryParams = new URLSearchParams(window.location.search);
    // const starttype = queryParams.get("starttype") || "";
    // console.log("useAIMIC useEffect", queryParams, starttype);
    // subscribeUseAIMicCb({ starttype });

    // 监听到通过AI麦克风启动个人端应用时，判断长按事件或者短按事件
    subscribeUseAIMic((data) => {
      subscribeUseAIMicCb(data.data);
    });

  }, []);

  return {subscribeUseAIMicCb};
};

export default useSubscribePressEvent;
